import styled from 'styled-components';

import { HueTextInput } from '../HueTextInput';

const StyledDot = styled.div`
	width: 6px;
	height: 6px;
	border-radius: 5px;
	background-color: rgba(0, 0, 0, 0.1);
`;

const StyledInputContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledHexTextInput = styled(HueTextInput).attrs({
	maxLength: 6,
	spellCheck: false,
} as React.HTMLAttributes<HTMLInputElement>)`
	width: 90px;
	height: 40px;
	padding-left: 25px;
`;

const StyledRgbTextInput = styled(HueTextInput).attrs({
	type: 'number',
	min: 0,
	max: 255,
} as React.HTMLAttributes<HTMLInputElement>)`
	width: 60px;
	height: 40px;

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`;

const StyledRgbContainer = styled.div`
	display: flex;
	gap: 10px;
	margin: 0 20px 0 30px;
`;

const StyledResetButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

export {
	StyledDot,
	StyledInputContainer,
	StyledHexTextInput,
	StyledRgbTextInput,
	StyledRgbContainer,
	StyledResetButton,
};
